import render from './render'

export default {
  name: 'Characters',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
